module.exports = __webpack_public_path__ + "media/images/emblems/Cadenazzo-coat_of_arms-de4c55a0b1506999c69d11753b8d3f85.svg";